import React from 'react'
import { AdsProvider } from './AdsProvider'
import { IsMobileProvider } from './IsMobileProvider'
import { UserProvider } from './UserProvider'
import { ConfigProvider } from './ConfigProvider'
import { ConsentProvider } from './ConsentProvider'

export const SharedContextProvider = ({ children }) => {
    return (
        <ConfigProvider>
            <AdsProvider>
                <IsMobileProvider>
                    <UserProvider>
                        <ConsentProvider>{children}</ConsentProvider>
                    </UserProvider>
                </IsMobileProvider>
            </AdsProvider>
        </ConfigProvider>
    )
}
